module.exports = __webpack_public_path__ + "images/157_4096.jpg";